var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWalletSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#28293D",
    d: "M18.833 11.017v1.717c0 .466-.383.85-.858.85h-1.609c-.9 0-1.725-.659-1.8-1.559-.05-.525.15-1.016.5-1.358a1.66 1.66 0 0 1 1.2-.5h1.709c.474 0 .858.383.858.85Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#28293D",
    d: "M13.317 12.133a2.949 2.949 0 0 1 .875-2.358 2.902 2.902 0 0 1 2.075-.858h.475c.233 0 .425-.192.392-.425a3.34 3.34 0 0 0-3.3-2.867H5.5a3.332 3.332 0 0 0-3.333 3.333v5.834A3.332 3.332 0 0 0 5.5 18.125h8.334a3.334 3.334 0 0 0 3.3-2.867c.033-.233-.159-.425-.392-.425h-.375c-1.583 0-2.917-1.183-3.05-2.7Zm-1.983-1.716h-5a.624.624 0 1 1 0-1.25h5a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625ZM12.342 3.817c.216.225.025.558-.292.558H5.525c-.908 0-1.758.267-2.466.725-.325.208-.767-.017-.609-.375a3.062 3.062 0 0 1 2.817-1.85H9.95c.967 0 1.825.342 2.392.942Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletSolid);
export default __webpack_public_path__ + "static/media/wallet-solid.e08dbd9147a7179738c9e60fef828066.svg";
export { ForwardRef as ReactComponent };